// Lists marked data-masonry-grid (the compatible amiibo under each feature on a game page) are laid out by Masonry, so
// panels of different heights pack into two columns without gaps. The figures' images are background images, which
// don't change the panels' heights as they load, and Masonry lays the panels out again when the window is resized.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-masonry-grid]').forEach((element) => new Masonry(element))
})
